
import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/jobBooking/Header/Header.vue';

@Component({
  components: {
    Header,
  },
})
export default class JobbookingView extends Vue {}
